import { AgentKeyAction, AgentKeyType } from '../field'
import { ThisConnector } from '../../../api/connector'
import { BaseApiResponse } from '../../../api/shared'
import { UseMutationOptions } from 'react-query'
import { useContrastMutation } from '../../../hooks/use-contrast-mutation'
import { HTTPError } from '../../../api/fetch/decorate-fetch'

export interface AgentKeyActionAuditLogArgs {
  orgUuid: string
  agentUid: string | null
  valueType: AgentKeyType
  action: AgentKeyAction
}

export async function addAgentAuditLog(
  this: ThisConnector,
  { orgUuid, agentUid, valueType, action }: AgentKeyActionAuditLogArgs
) {
  return this.connector.post<BaseApiResponse>(
    `organizations/${orgUuid}/agent-users/log`,
    {
      agentUid,
      valueType,
      action
    }
  )
}

interface Response {
  readonly success: boolean
  readonly messages: string[]
}

export function useAddAgentAuditLog(
  options?: UseMutationOptions<Response, Error, AgentKeyActionAuditLogArgs>
) {
  return useContrastMutation<Response, HTTPError, AgentKeyActionAuditLogArgs>(
    addAgentAuditLog,
    options
  )
}
